import { NullableSignalLine } from "./nullable-signal-line";
import { ConstIsolineSignalBuffer } from "./const-isoline-signal-buffer";

export class ConstIsolineSignalLine extends NullableSignalLine {
  constructor(settings) {
    super(settings);
  }

  createBuffer(settings) {
    this.signalBuffer = new ConstIsolineSignalBuffer(settings);
  }

  init() {
    const bufferSettings = {
      pointCounterCreator: this.settings.pointCounterCreator,
      ppmm: this.settings.ppmm,
      plotSize: this.settings.parent.ref.settings.clientSize,
      windowSize: this.settings.parent.ref.settings.clientSize,
      freq: this.settings.freq,
      scaleX: this.settings.scaleX * this.settings.viewScale.x,
      scaleY: this.settings.scaleY * this.settings.viewScale.y,
      valuePixelConvertKoef: this.settings.valuePixelConvertKoef,
      isDataSync: !this.settings.isBuffered,
      dataBufferSize: this.settings.dataBufferSize,
      pointCount: this.settings.pointCount
    };
    this.createBuffer(bufferSettings);
    this.signalBuffer.init();

    const gl = this.settings.gl;
    this.glBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.glBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.signalBuffer.pointBuffer, gl.DYNAMIC_DRAW);
  }

  tryUpdateMeanSignalValue() {
    this.signalBuffer.tryUpdateMeanSignalValue();
  }
}
